import { ActionType } from 'typesafe-actions';
import {
    all, call, Effect, put, take, takeLatest,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';

import { AwsIotService } from '../../services/awsIOT/typings';
import commonApiService from '../../services/api/commonApiService';

import { setSignedWebSocketUrl, fetchSignedWebSocketUrl } from './actions';
import { SessionTypeKeys } from './types';
import * as constants from './constants';
import commonRoutingService from '../../services/commonRoutingService';

let awsIOTService: AwsIotService;

export const configureSessionSagas = (serviceImplementation: AwsIotService) => {
    awsIOTService = serviceImplementation;
};

// Retry if fail
function* callFetchSignedWebSocketUrl(): any {
    try {
        const data = yield call(commonApiService.fetchSignedWebSocketUrl);
        yield put(setSignedWebSocketUrl(data.signedWebSocketUrl));
    } catch (error) {
        console.log(error);
        yield delay(20000);
        yield put(fetchSignedWebSocketUrl());
    }
}

function* callLogout() {
    try {
        yield call(commonApiService.logout);
        window.location.href = '/admin';
    } catch (error) {
        yield put({ error, type: 'LOGOUT_FAILED' });
    }
}

function* callSetupClient({ payload }: ActionType<typeof setSignedWebSocketUrl>): IterableIterator<any> {
    yield call([awsIOTService, awsIOTService.setupClient], payload.signedWebSocketUrl);
}

function* callRedirectToLastVisitedUrl(): IterableIterator<void> {
    yield commonRoutingService.navigateToLastVisitedUrl();
}

function* callReloadPage(): IterableIterator<void> {
    yield window.location.reload();
}

function* watchFetchSignedWebSocketUrl(): IterableIterator<Effect> {
    yield takeLatest(constants.FETCH_SIGNED_WEBSOCKET_URL, callFetchSignedWebSocketUrl);
}

function* watchSetSignedWebSocketUrl(): IterableIterator<Effect> {
    yield takeLatest(constants.SET_SIGNED_WEBSOCKET_URL, callSetupClient);
}

function* watchFirstUserInfoSet(): IterableIterator<Effect> {
    yield take(SessionTypeKeys.SET_USER_INFO);
    yield call(callRedirectToLastVisitedUrl);
}

function* watchLogoutAction() {
    yield takeLatest(SessionTypeKeys.LOGOUT_USER, callLogout);
}

function* watchLanguageChange() {
    yield takeLatest(SessionTypeKeys.SET_LANGUAGE, callReloadPage);
}

export function* rootSessionSaga(): IterableIterator<any> {
    yield all([
        watchFetchSignedWebSocketUrl(),
        watchSetSignedWebSocketUrl(),
        watchFirstUserInfoSet(),
        watchLogoutAction(),
        watchLanguageChange(),
    ]);
}
